import axios from "axios";
import { SuperAdminURL } from "../../../../config/UrlEndPoint";

export const URL = `${SuperAdminURL}organization`;

//  * FIND ORGANIZATION REPORT
export function findConsolidationReport(queryParams) {
  return axios.post(`${URL}/find_consolidation_report`, queryParams);
}
// * UPDATE STATUS ORGANIZATION REPORT
export function createConsolidationReport(payload) {
  return axios.put(`${URL}/update_status_report`, payload);
}

export const generateMemoPPD = id => {
  return axios({
    url: `${URL}/generate_memo/${id}`,
    method: "GET",
    responseType: "blob"
  });
};
